"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = {
  sidebarTitleEn: 'Title',
  sidebarTitleEs: 'Título',
  mustTakeInOrder: true,
  enablePrintMode: false
};
exports.initialValues = initialValues;
var Settings = function Settings(_ref) {
  var questSettings = _ref.questSettings;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, questSettings.languages.includes('en') && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "sidebarTitleEn",
    component: _cccisdFormik.CccisdInput,
    label: "Sidebar title (English)",
    showErrorImmediately: true
  }), questSettings.languages.includes('es') && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "sidebarTitleEs",
    component: _cccisdFormik.CccisdInput,
    label: "Sidebar title (Spanish)",
    showErrorImmediately: true
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "mustTakeInOrder",
    component: _cccisdFormik.CccisdToggle,
    label: "User must take surveys in order"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "enablePrintMode",
    component: _cccisdFormik.CccisdToggle,
    label: "User can save their survey responses to PDF"
  }));
};
var _default = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);
exports["default"] = _default;